import React from 'react';

interface MenuLabelProps {
  text: string;
}

/**
 * Sidebar menu label. Every label renders at the single font-size and weight the
 * stylesheet defines; a title too long for the 180px sidebar ("Company
 * Customizations") wraps onto a second balanced line instead of being shrunk or
 * truncated, so the list keeps one consistent typography scale.
 */
export const MenuLabel: React.FC<MenuLabelProps> = ({ text }) => (
  <span className="menu-label" title={text}>
    {text}
  </span>
);

export default MenuLabel;
